import MarkerDetails from "./MarkerDetails";

export default MarkerDetails;